import { render, staticRenderFns } from "./ArtifactGroups.vue?vue&type=template&id=07524d20&scoped=true&"
import script from "./ArtifactGroups.vue?vue&type=script&lang=js&"
export * from "./ArtifactGroups.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactGroups.vue?vue&type=style&index=0&id=07524d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07524d20",
  null
  
)

export default component.exports